module.exports = __webpack_public_path__ + "img/0d9e6205a635abf58c3ec7c4a58a935b.png";